<template>
  <EasyPage>
    <SearchPanel name="operation-record-query">
      <SearchCondition no-setting no-shortcut>
        <sf-input name="keyword" label="员工编号、昵称、手机号" />

        <sf-date-range :name="['timeBegin', 'timeEnd']" label="操作时间" />
      </SearchCondition>

      <SearchTable
        url="/api/tm/unified-login/v5/admin/log/operation"
        :column-defs="OperationRecordClass"
        :row-height="60"
      />
    </SearchPanel>
  </EasyPage>
</template>

<script lang="tsx" setup>
import * as easy from "@/components/easy";
import { ColInfo } from "@/components/easy";

// 表格行定义
class OperationRecordClass {
  @easy.RowId()
  id = "";

  @ColInfo("昵称", { width: 120 })
  nickname = "";

  @ColInfo("操作内容", { flex: 1 })
  message = "";

  @ColInfo("操作时间", easy.datetimef)
  createTime = "";
}
</script>
